import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
})
export class SkeletonComponent implements OnInit {

  @Input() public type: string = "";
  @Input() public animated: boolean = false;

  constructor() { }

  ngOnInit() { }

}
